import { render } from "./PublicMesh.vue?vue&type=template&id=2d6d0cf9&scoped=true"
import script from "./PublicMesh.vue?vue&type=script&lang=js"
export * from "./PublicMesh.vue?vue&type=script&lang=js"

import "./PublicMesh.vue?vue&type=style&index=0&id=2d6d0cf9&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6d0cf9"]])

export default __exports__